import React from 'react';

const isVideo = (src: string) => src.includes('.mp4');

type MediaProps =
  | React.ImgHTMLAttributes<HTMLImageElement>
  | React.VideoHTMLAttributes<HTMLVideoElement>;

export const Media: React.FC<MediaProps> = (props) => {
  const { src } = props;
  if (!src) return null;
  if (isVideo(src)) {
    // Remove alt from props if it exists, as video doesn't support it
    const { ...videoProps } =
      props as React.VideoHTMLAttributes<HTMLVideoElement>;
    return <video autoPlay loop muted playsInline {...videoProps} />;
  }
  const { ...imgProps } = props as React.ImgHTMLAttributes<HTMLImageElement>;
  return <img {...imgProps} alt={imgProps.alt || ''} />;
};
